<div class="ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'paperlessCommercialInvoice.dialog.settings.title' | translate }}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button"
                mat-raised-button
                class="icon-button close-button"
                [mat-dialog-close]="false" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <div class="enrollment-message">
            {{ 'paperlessCommercialInvoice.dialog.settings.message' | translate }}
        </div>
        <div class="enrollment-note">
            {{ 'paperlessCommercialInvoice.dialog.settings.note' | translate }}
        </div>
        <div class="divider"></div>

        <div class="error-message" *ngIf="showFileSizeExceededError">{{ 'paperlessCommercialInvoice.dialog.settings.fileSizeExceeded' | translate }}</div>

        <div class="error-message" *ngIf="letterHeadAndSignatureErrorMessage"> {{ 'paperlessCommercialInvoice.dialog.settings.bothFilesSizeExceeded' | translate }} </div>

        <div class="upload letterhead">
            <div class="actions">
                <!-- <label>
                    <input type="file"
                           accept=".jpg,.png"
                           (change)="uploadImage($event, 'letterhead')">
                    <a mat-raised-button
                       class="secondary-button dense">
                        {{ 'paperlessCommercialInvoice.dialog.settings.letterhead.upload' | translate }}
                    </a>
                </label> -->
                <!-- MV3-3890 - File Control not working in IE -->
                <upsc-file-selector [label]="'paperlessCommercialInvoice.dialog.settings.letterhead.upload' | translate"
                                    [fileTypes]="'.jpg,.png'"
                                    [buttonClass]="'upload-btn dense'"
                                    [clearFileControl]="true"
                                    [letterheadImage]="letterheadImage"
                                    [signatureImage]="signatureImage"
                                    [isLetterHead]="true"
                                    (fileSelectionChanged)="uploadImage($event, 'letterhead')"></upsc-file-selector>
                <a mat-raised-button
                   class="transparent-button dense cancel"
                   [disabled]="!letterheadImage"
                   (click)="removeImage($event, 'letterhead', !letterheadImage)">
                    {{ 'paperlessCommercialInvoice.dialog.settings.letterhead.remove' | translate }}
                </a>
            </div>
            <div class="preview">
                <div class="image-container">
                    <img *ngIf="letterheadImage"
                         [src]="'data:image/png;base64,' + letterheadImage?.Document | safe:'resourceUrl'"
                         alt="Letterhead">
                </div>
                <span class="image-restrictions">
                        {{ 'paperlessCommercialInvoice.dialog.settings.letterhead.imageRestrictions' | translate}}
                    </span>
            </div>
        </div>
        <div class="upload signature">
            <div class="actions">
                <!-- <label>
                    <input type="file"
                           accept=".jpg,.png"
                           (change)="uploadImage($event, 'signature')">
                    <a mat-raised-button
                       class="secondary-button dense">
                        {{ 'paperlessCommercialInvoice.dialog.settings.signature.upload' | translate }}
                    </a>
                </label> -->
                <!-- MV3-3890 - File Control not working in IE -->
                <upsc-file-selector [label]="'paperlessCommercialInvoice.dialog.settings.signature.upload' | translate"
                                    [fileTypes]="'.jpg,.png'"
                                    [buttonClass]="'upload-btn dense'"                                 
                                    [clearFileControl]="true"
                                    [letterheadImage]="letterheadImage"
                                    [signatureImage]="signatureImage"
                                    [isSignature]="true"
                                    (fileSelectionChanged)="uploadImage($event, 'signature')"></upsc-file-selector>
                <a mat-raised-button
                   class="transparent-button dense cancel"
                   [disabled]="!signatureImage"
                   (click)="removeImage($event, 'signature', !signatureImage)">
                    {{ 'paperlessCommercialInvoice.dialog.settings.signature.remove' | translate }}
                </a>
            </div>
            <div class="preview">
                <div class="image-container">
                    <img *ngIf="signatureImage"
                         [src]="'data:image/png;base64,' + signatureImage?.Document | safe:'resourceUrl'"
                         alt="Letterhead">
                </div>
                <span class="image-restrictions">
                        {{ 'paperlessCommercialInvoice.dialog.settings.signature.imageRestrictions' | translate}}
                    </span>
            </div>
        </div>

        <div class="upload-note">
            {{ 'paperlessCommercialInvoice.dialog.settings.uploadNote' | translate}}
        </div>
    </mat-dialog-content>
    <div class="mat-dialog-actions">
        <button mat-raised-button class="action-btns cancel" (click)="closeDialog($event, false)">
            {{ 'paperlessCommercialInvoice.dialog.settings.cancel' | translate }}
        </button>
        <button mat-raised-button
                type="submit"
                class="action-btns submit-btn"
                *ngIf="!isEdit || (isEdit && (!!letterheadImage || !!signatureImage))"
                [disabled]="!formGroup.valid"
                (click)="saveAllImages($event)">
            <span *ngIf="!isEdit">{{ 'paperlessCommercialInvoice.dialog.settings.submitNew' | translate }}</span>
            <span *ngIf="isEdit">{{ 'paperlessCommercialInvoice.dialog.settings.submitUpdate' | translate }}</span>
        </button>
        <button mat-raised-button
                type="submit"
                class="action-btns submit-btn"
                *ngIf="isEdit && !letterheadImage && !signatureImage"
                [disabled]="!formGroup.valid"
                (click)="saveAllImages($event)">
            <span>{{ 'paperlessCommercialInvoice.dialog.settings.submitUpdate' | translate }}</span>
        </button>
    </div>
</div>
